import React from 'react'
import { observer } from 'mobx-react'
import { Card } from '@winnin/winnin_ui.components.card'
import { Chip } from '@winnin/winnin_ui.components.chip'

import NoDataAvailable from 'components/NoDataAvailable'
import { RCTooltip } from 'components/RCTooltip'
import { tagsAsFormat } from 'consts'

import './index.scss'

const TagCloud = observer(({ tags, onTagClick, selectedTag, limit, showIndex = true, showExtraTags = false }) => {
  const tagsToRender = limit ? tags.slice(0, limit) : tags

  const ButtonTagCloud = (tag, i, variation) => (
    <Chip
      index={showIndex && i + 1}
      handleClick={() => onTagClick(tag)}
      isActive={selectedTag === tag}
      variation="outline"
      className={`tag-cloud-chip ${variation === 'highlighted' ? 'chip-highlighted' : ''}`}
      title={tag}
    />
  )

  return (
    <div className="tag-cloud-component">
      {Array.isArray(tagsToRender) && tagsToRender.length ? (
        <>
          {tagsToRender.map((tag, i) => {
            if (tagsAsFormat[tag]) {
              return (
                <RCTooltip
                  direction="top"
                  key={`help-tt-tag${i}`}
                  tooltipMessage={`This tag is referring to the video format "${tagsAsFormat[tag]}"`}
                >
                  {ButtonTagCloud(tag, i, 'highlighted')}
                </RCTooltip>
              )
            } else {
              return <span key={`help-tt-tag${i}`}>{ButtonTagCloud(tag, i, 'default')}</span>
            }
          })}
          {showExtraTags && tags.length > limit && (
            <RCTooltip direction="top" tooltipMessage={tags.slice(limit, tags.length).join(', ')}>
              <Chip variation="outline" title={`+ ${tags.length - limit} tags`} />
            </RCTooltip>
          )}
        </>
      ) : (
        <Card className="card-content">
          <NoDataAvailable />
        </Card>
      )}
    </div>
  )
})

TagCloud.propTypes = {}

TagCloud.defaultProps = {}

TagCloud.displayName = 'TagCloud'

export default TagCloud
